import {Parent} from 'app/types/appBar/Parent';
import {ParentEntity} from 'app/types/appBar/ParentEntity';

interface District {
  id: number;
  name: string;
  middleName: string;
  shortName: string;
  slug: string;
  region: {
    id: number;
    name: string;
    slug: string;
    linkUrl: string;
  };
}

export class DistrictChangeParentFactory {
  static create(district: District): Parent {
    if (!district) {
      throw new Error('District is required to create a parent');
    }

    return {
      entity: ParentEntity.Region,
      name: district.name,
      slugs: {regionSlug: district.region.slug},
    };
  }
}
